export default function Clock({fill}) {
  return (
    <>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.64044 0.765991C4.5295 0.765991 3.44351 1.09542 2.5198 1.71263C1.59609 2.32983 0.876146 3.20709 0.451009 4.23346C0.0258713 5.25983 -0.0853641 6.38922 0.131369 7.47881C0.348102 8.5684 0.88307 9.56926 1.66862 10.3548C2.45417 11.1404 3.45503 11.6753 4.54462 11.8921C5.63421 12.1088 6.7636 11.9976 7.78997 11.5724C8.81635 11.1473 9.6936 10.4273 10.3108 9.50363C10.928 8.57992 11.2574 7.49393 11.2574 6.38299C11.2574 5.64536 11.1122 4.91494 10.8299 4.23346C10.5476 3.55197 10.1338 2.93276 9.61226 2.41117C9.09067 1.88959 8.47146 1.47584 7.78997 1.19356C7.10849 0.911279 6.37807 0.765991 5.64044 0.765991ZM8.23344 7.24699H5.64044C5.58371 7.24699 5.52753 7.23582 5.47512 7.21411C5.42271 7.1924 5.37508 7.16058 5.33497 7.12046C5.29486 7.08035 5.26303 7.03272 5.24132 6.98031C5.21961 6.9279 5.20844 6.87172 5.20844 6.81499V2.92599C5.20844 2.81142 5.25395 2.70154 5.33497 2.62052C5.41599 2.53951 5.52587 2.49399 5.64044 2.49399C5.75501 2.49399 5.86489 2.53951 5.94591 2.62052C6.02693 2.70154 6.07244 2.81142 6.07244 2.92599V6.38299H8.23244C8.34701 6.38299 8.45689 6.42851 8.53791 6.50952C8.61893 6.59054 8.66444 6.70042 8.66444 6.81499C8.66444 6.92956 8.61893 7.03945 8.53791 7.12046C8.45689 7.20148 8.34701 7.24699 8.23244 7.24699H8.23344Z"
          fill={fill ?? "#004E99"}
        />
      </svg>
    </>
  );
}
